var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "选择任务", clearable: "" },
                      model: {
                        value: _vm.searchForm.taskId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "taskId", $$v)
                        },
                        expression: "searchForm.taskId",
                      },
                    },
                    _vm._l(_vm.actLists, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.taskName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.postStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "postStatus", $$v)
                        },
                        expression: "searchForm.postStatus",
                      },
                    },
                    _vm._l(_vm.postStatusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "帖子标签", clearable: "" },
                      model: {
                        value: _vm.searchForm.qualityLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "qualityLevel", $$v)
                        },
                        expression: "searchForm.qualityLevel",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "优秀", value: "0" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "普通", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "低质", value: "2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.changeTime },
                    model: {
                      value: _vm.times,
                      callback: function ($$v) {
                        _vm.times = $$v
                      },
                      expression: "times",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  width: "60",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "手机号", prop: "mobile", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员名称", prop: "userName", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "员工姓名",
                  prop: "officerName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "任务名称", prop: "taskName", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "帖子类型", prop: "userType", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.userType == 1
                          ? _c("div", [_vm._v("员工")])
                          : scope.row.userType == 2
                          ? _c("div", [_vm._v("用户")])
                          : _c("div", [_vm._v("全部")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "帖子标签",
                  prop: "qualityLevel",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.qualityLevel == 0
                          ? _c("div", [_vm._v("优秀")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.qualityLevel == 1
                          ? _c("div", [_vm._v("普通")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.qualityLevel == 2
                          ? _c("div", [_vm._v("低质")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "是否优质帖",
                  prop: "isQuality",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isQuality
                          ? _c("div", [_vm._v("是")])
                          : _c("div", [_vm._v("否")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "发帖时间",
                  prop: "createDate",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", prop: "postStatus", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.postStatus == 1
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("待审核"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("系统审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("系统审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 4
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("审核通过不发奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 5
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("人工审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 6
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("人工审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 7
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("人工审核通过不发奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 8
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("已发放奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 9
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("优质帖待审核"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 10
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("优质帖审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 11
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("优质帖审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.postStatus == 12
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("优质奖励已发放"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "210",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.postDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        scope.row.postStatus >= 8
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.postReward(
                                      scope.row,
                                      scope.row.id
                                    )
                                  },
                                },
                              },
                              [_vm._v("奖励信息")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "帖子详情",
            "close-on-click-modal": true,
            visible: _vm.showPostDialog,
            width: "60%",
            "custom-class": "post-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPostDialog = $event
            },
          },
        },
        [_c("post-detail", { attrs: { post: _vm.selectedPost } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "奖励信息",
            visible: _vm.showRewardDialog,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRewardDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.rewardLoading,
                  expression: "rewardLoading",
                },
              ],
              attrs: { "element-loading-text": "加载中..." },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.rewardList, stripe: "", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "rewardType", label: "奖励类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.rewardType == 1
                              ? _c("div", [_vm._v("积分")])
                              : scope.row.rewardType == 2
                              ? _c("div", [_vm._v("优惠券")])
                              : _c("div", [_vm._v("实物")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "rewardValue", label: "奖励值" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.rewardType == 1
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.rewardValue) + "积分"
                                  ),
                                ])
                              : scope.row.rewardType == 3
                              ? _c("div", [
                                  _vm._v(_vm._s(scope.row.rewardValue)),
                                ])
                              : _c("div", [
                                  _vm._v(_vm._s(scope.row.couponName)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status == 0
                              ? _c("div", [_vm._v("待发放")])
                              : scope.row.status == 1
                              ? _c("div", [_vm._v("发放中")])
                              : scope.row.status == 2
                              ? _c("div", [_vm._v("发放成功")])
                              : scope.row.status == 3
                              ? _c("div", [_vm._v("发放失败")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "createDate", label: "创建时间" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showRewardDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }